<template>
  <div class="odds-change-page">
    <div class="module" style="margin-bottom: 0">
      <div class="content">
        <div class="search-box">
          <span>号码：</span>
          <input style="margin-right: 10px" class="input left" type="text" />
          <button style="margin-right: 10px" class="btn primary">查询</button>
          <button style="margin-right: 10px" class="btn plain">清空</button>
        </div>
      </div>
    </div>
    <div class="module" style="margin-bottom: 0">
      <div class="title">
        <span style="margin: 0 10px">一字定</span>
        <span style="margin: 0 10px">二字定</span>
        <span style="margin: 0 10px">三字定</span>
        <span style="margin: 0 10px">四字定</span>
      </div>
      <div class="content">
        <div class="nav-title">
          <span class="active-text" style="margin: 0 15px">口XXXX</span>
          <span style="margin: 0 15px">X口XXX</span>
          <span style="margin: 0 15px">XX口XX</span>
          <span style="margin: 0 15px">XXX口X</span>
          <span style="margin: 0 15px">XXXX口</span>
        </div>
        <table style="width: 100%" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
              <th>号码</th>
              <th class="active-text border">赔率</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0XXXX</td>
              <td class="active-text border">9.99</td>
              <td>1XXXX</td>
              <td class="active-text border">9.99</td>
              <td>2XXXX</td>
              <td class="active-text border">9.99</td>
              <td>3XXXX</td>
              <td class="active-text border">9.99</td>
              <td>4XXXX</td>
              <td class="active-text border">9.99</td>
              <td>5XXXX</td>
              <td class="active-text border">9.99</td>
              <td>6XXXX</td>
              <td class="active-text border">9.99</td>
              <td>7XXXX</td>
              <td class="active-text border">9.99</td>
              <td>8XXXX</td>
              <td class="active-text border">9.99</td>
              <td>9XXXX</td>
              <td class="active-text border">9.99</td>
            </tr>
          </tbody>
        </table>
        <Paging
          class="center"
          style="margin-right: 20px"
          :current_page="current_page"
          :last_page="last_page"
          @pre="pre()"
          @next="next()"
          @goFirst="firstPage()"
          @goLast="lastPage()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Paging";
export default {
  components: { Paging },
};
</script>

<style lang="scss" scoped>
.odds-change-page {
  .search-box {
    padding: 10px 20px;
    .input {
      height: 26px;
    }
    .btn {
      width: unset;
    }
  }
  .nav-title {
    line-height: 30px;
    height: 30px;
    text-align: center;
    > span {
      margin: 0 10px;
    }
  }
  table {
    border: 1px solid var(--primary-table-border-color);
    tr {
      th,
      td {
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
        text-align: left;
        &.border {
          border-right: 1px solid var(--primary-table-border-color);
        }
      }
      th {
        border-bottom: 1px solid var(--primary-table-border-color);
      }
      &:not(:last-child) {
        // th,
        td {
          border-bottom: 1px solid var(--primary-table-border-color);
        }
      }
    }
  }
}
</style>
